import { Component } from "@angular/core";
import {
  AuthenticationService,
  UtilityService
} from "./../../providers";
import { PageLoaderService } from "../../ui-components/page-loader/page-loader.service";
import { HttpResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { LOGIN_ERROR } from "../../../../../config";

@Component({
  selector: "app-login",
  template: "",
})
export class LoginComponent {
  private rkey = '';
  loginErrorMessage: string;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private pageloaderService: PageLoaderService, private route: ActivatedRoute) {

      //handle multi-stubid using param through login
      if(this.router.routerState.snapshot.url.indexOf("dmp_unique_stubid") != -1){
          this.route.queryParamMap.subscribe((data: any) => {
              let parm = data["params"];
              console.log("params==>", parm);
              localStorage.setItem("dmp_unique_stubid", parm.dmp_unique_stubid);
          })
      }

      //handle HALO.X authentication route
      const afterLoginIndex = window.location.href.indexOf('login');
      let afterLogin = window.location.href.substr(afterLoginIndex+5);
      if ( afterLogin.length > 1 ) {
        console.warn('Depricate login url parameters: ' + afterLogin);
        localStorage.setItem('LOGIN_HALO', afterLogin);
        window.location.href = '/businessconsole/login';
        return;
      } else {
        afterLogin = localStorage.getItem('LOGIN_HALO');
        localStorage.removeItem('LOGIN_HALO');
      }

    const urlParams = new URLSearchParams(afterLogin);
    this.rkey = urlParams.get('rkey');

    if (this.authenticationService.checkIfAuthNeeded()) {
      history.back();
    } else {
      sessionStorage.clear();

      this.pageloaderService.setPageLoaderStatus(false);
      this.authenticationService.validateUser()
        .subscribe(
          (resp: any) => {
            if( resp.body && resp.body != null){
              localStorage.setItem('hideMenu', "true");
              localStorage.setItem('hideHeader', "true");
              this.router.navigate(['selectstubid']);             
            }
            else{
              this.authenticationService.navigateAfterLogin(this.rkey)
            }  
          }, 
          error => {
            // if(error.status == '475' || error.status == '476' || error.status == '477' || error.status == '471' || error.status == '472') {
            //   this.authenticationService.handleLoginError(error.status);
            // }else 
              
            if(error.error != null ){
              if(error.error.text != null && error.error.text.indexOf('401') != -1) {
                sessionStorage.setItem('stubIdError', 'true');
                localStorage.setItem('loginSuccessUrl', 'home');
                localStorage.setItem('profileLogin', 'true');
              } else {
                sessionStorage.removeItem('stubIdError');
              }
            }
              this.authenticationService.handleLoginError(error.status);
          },
        )
    }
  }

  

}